<script setup lang="ts">
import type { Article } from "~/types/article"

const { title = "Laster..." } = defineProps<{
  title?: string
  restricted?: boolean
  img: Article["img"]
}>()
</script>

<template>
  <div
    class="relative flex size-full overflow-clip rounded-xl bg-platform-paper font-national2condensed"
    :class="{
      'brightness-[85%]': restricted,
    }"
  >
    <h3
      class="absolute inset-0 z-10 flex size-full items-center justify-center bg-black/50 p-4 font-national2compressed text-4xl font-medium uppercase text-white lg:text-6xl"
    >
      Intro: {{ title }}
    </h3>
    <img
      v-if="img?.src"
      class="absolute size-full object-cover"
      :src="img.src"
      :alt="img.alt"
    />
  </div>
</template>
